import { toastInfo, toastSuccess } from '../utils/toastMessage';
import API from '../utils/API';

export const filterMenuSuccess = (data) => {
  return {
    type: 'FILTER_MENU_SUCCESS',
    data,
  };
};

export const filterMenuError = () => {
  return {
    type: 'FILTER_MENU_ERROR',
  };
};

export const clearAllMenus = () => {
  return {
    type: 'CLEAR_ALL_MENUS',
  };
};

export const showAllMenus = () => {
  return {
    type: 'SHOW_ALL_MENUS',
  };
};

export const filterMenu = (choosedTagsIds, userId) => {
  const queryStrTags = choosedTagsIds.join('|');
  return (dispatch) => {
    API.get(`/menus?tags=${queryStrTags}&userid=${userId}`)
      .then((response) => {
        toastSuccess();
        dispatch(filterMenuSuccess(response.data.data));
      })
      .catch(function () {
        dispatch(filterMenuError());
        toastInfo('Меню не было найдено..');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/menuFilter.js